import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --sigeclin-primary: #1f725f;
    --sigeclin-primary-dark: #155d4b;
    --sigeclin-accent: #2f5d89;
    --sigeclin-surface: #ffffff;
    --sigeclin-surface-muted: #f8fcfa;
    --sigeclin-page-bg: #f4faf7;
    --sigeclin-border: rgba(24, 90, 66, 0.12);
    --sigeclin-text: #143d30;
    --sigeclin-text-soft: #5f7f73;
    --sigeclin-shadow: 0 20px 60px rgba(18, 62, 51, 0.08);
  }

  * {
    box-sizing: border-box;
  }

  html {
    min-height: 100%;
    background: var(--sigeclin-page-bg);
  }

  body {
      min-height: 100vh;
      margin: 0;
      font-family: 'Segoe UI', sans-serif;
      background:
        radial-gradient(circle at 8% 10%, rgba(110, 185, 160, 0.1), transparent 24%),
        radial-gradient(circle at 92% 5%, rgba(53, 109, 159, 0.08), transparent 20%),
        linear-gradient(180deg, #f5fbf8 0%, #edf3fb 100%);
      color: var(--sigeclin-text);
  }

  #root {
    min-height: 100vh;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  .ant-card {
    border-color: var(--sigeclin-border);
    box-shadow: var(--sigeclin-shadow);
  }

  .ant-input,
  .ant-input-affix-wrapper,
  .ant-picker,
  .ant-select:not(.ant-select-disabled) .ant-select-selector {
    background-color: #ffffff !important;
  }

  .ant-input:hover,
  .ant-input:focus,
  .ant-input-affix-wrapper:hover,
  .ant-input-affix-wrapper-focused,
  .ant-picker:hover,
  .ant-picker-focused,
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector,
  .ant-select-focused:not(.ant-select-disabled) .ant-select-selector {
    background-color: #ffffff !important;
  }

  .ant-layout {
    background: transparent;
  }

  .ant-divider {
    border-color: rgba(24, 90, 66, 0.08);
  }

  .ant-statistic .ant-statistic-content {
    letter-spacing: -0.02em;
  }
  .vazio {
    fill: none;
    stroke: #555;
  }
  .desabilitado {
    fill: black;
    stroke: black;
    stroke-width: 1px;
    opacity: 0.3;
  }
  .marcadoAzul {
    fill: none;
    stroke: #0000ff;
    stroke-width: 4;
    cursor: pointer;
  }
  .marcadoAzulClaro {
    fill: #17a2b8;
    stroke: black;
    stroke-width: 1px;
  }
  .marcadoVerde {
    fill: green;
    stroke: black;
    stroke-width: 1px;
  }
  .marcadoVerdeClaro {
    fill: none;
    stroke: #04cf17;
    stroke-width: 2px;
    cursor: pointer;
  }
  .marcadoRoxo {
    fill: #cc66cc;
    stroke: black;
    stroke-width: 1px;
    stroke-width: 0.5;
    cursor: pointer;
  }
  .marcadoMarrom {
    fill: #cc6600;
    stroke: black;
    stroke-width: 1px;
  }
  .marcadoAmarelo {
    fill: yellow;
    stroke: black;
    stroke-width: 1px;
  }
  .marcadoVermelho {
    fill: red;
    stroke: black;
    stroke-width: 1px;
  }
  .marcadoLaranja {
    fill: none;
    stroke: #ffa500;
    stroke-width: 4;
    cursor: pointer;
  }
  .marcadoTomate {
    fill: none;
    stroke: #ff6347;
    stroke-width: 2;
    cursor: pointer;
  }
  .dente {
    fill: white;
    stroke: #555;
    stroke-width: 0.5;
    cursor: pointer;
  }
  .ausente {
    fill: none;
    opacity: 0;
  }
  .coroa {
    fill: none;
    opacity: 0;
  }
  .endodoncia {
    fill: none;
    opacity: 0;
  }

  .implante {
    fill: none;
    opacity: 0;
  }

`;
